import { useSelector } from 'react-redux';
import { AnimatePresence } from 'framer-motion';
import { NavbarStudent, NavbarTutor } from '../components/navbar';
import { ProfileRole } from '../store/profile/profileSlice';
import { TopBar } from '../components/topBar/TopBar';

const PrivateLayout = ({ component: Component, ...props }) => {
	const { currentProfile } = useSelector((state) => state.profile);

	return (
		<>
			{

				<div className="bg-black bg-opacity-5 flex flex-col md:flex-row justify-between items-start">
					{currentProfile?.role === ProfileRole.TUTOR && <NavbarTutor />}
					{currentProfile?.role === ProfileRole.STUDENT && <NavbarStudent />}


					<AnimatePresence>

						<div
							className="relative z-99  w-full h-[calc(100vh-70px)] xl:h-screen overflow-y-auto px-5 pb-5 mr-5 ml-auto mt-[60px] md:pl-20 xl:pl-5 xl:w-[calc(100%-320px)] xl:mr-[10px] xl:mt-0"
							id="page-content"
						>
							<div className="sticky top-0 z-40 -mx-5 pb-2 mb-2">
								<TopBar />
							</div>
							<Component {...props} />
						</div>
					</AnimatePresence>
				</div>
			}
		</>
	);
};

export { PrivateLayout };
